// @flow
import React from 'react'
import {
  Toolbar,
  Grid,
  Typography
} from '@material-ui/core'
import i18n from 'i18next'

import styles from './styles'

type Props = {
  isAtMobile?: boolean
}

export const FreeDeliveryMessage = (props: Props) => (
  <Toolbar variant='dense' style={styles.toolbar}>
    <Grid container justify='center'>
      <Typography style={styles.text(props.isAtMobile)} variant='caption' align='center'>
        <b>{i18n.t('home.freeDeliveryMessage')}</b>
      </Typography>
    </Grid>
  </Toolbar>
)

export default FreeDeliveryMessage
